export enum FileCategory {
  // ================= ORGANIZATION =================
  MISAAL_SHAREEF = 'misaal-shareef',

  DIRECTIVES = 'directives',

  DIRECTIVES_PHOTO = 'directives-photo',

  MAZAAR_PROPERTY_MAP = 'mazaar-property-map',

  // ================= REGISTRATION =================
  ADDRESS_PROOF = 'address-proof',

  PTR_DOCUMENT = 'ptr-document',

  TRUST_DEED = 'trust-deed',

  TRUST_REGISTRATION_CERTIFICATE = 'trust-registration-certificate',

  CHANGE_REPORTS = 'change-reports',

  CHARITY_PERMISSIONS = 'charity-permissions',

  PAN_CARD_OF_TRUST = 'pan-card-of-trust',

  TWELVE_AA_80G_CERTIFICATES = '12aa-80g-certificates',

  RESOLUTION_REGISTER = 'resolution-register',

  BANK_ACCOUNT_DETAILS = 'bank-account-details',

  WAQF_DEED = 'waqf-deed',

  WAQF_REGISTRATION_CERTIFICATE = 'waqf-registration-certificate',

  CHANGE_ORDER = 'change-order',

  WAQF_BOARD_INTIMATION = 'waqf-board-intimation',

  SANCTION_ORDERS = 'sanction-orders',

  WAQF_BOARD_AUDIT_REPORTS = 'waqf-board-audit-reports',

  WAQF_PROPERTY_LIST = 'waqf-property-list',

  // ================= PROPERTY =================
  PROPERTY_CARD = 'property-card',

  ACQUISITION_DOCUMENT = 'acquisition-document',

  NON_AGRICULTURAL_CERTIFICATE = 'non-agricultural-certificate',

  CONSTRUCTION_PERMISSIONS = 'construction-permissions',

  BUILDING_PLAN_APPROVALS = 'building-plan-approvals',

  FEE_PAYMENT_RECEIPTS = 'fee-payment-receipts',

  ENVIRONMENTAL_CLEARANCE = 'environmental-clearance',

  FIRE_SAFETY_CERTIFICATE = 'fire-safety-certificate',

  PROPERTY_PHOTO = 'property-photo',

  JANTRI_DOCUMENT = 'jantri-document',

  JANTRI_DATE = 'jantri-date',

  PROPERTY_HOUSE_TAX_BILL = 'property-house-tax-bill',

  // ================= SUB PROPERTY =================
  COMMERCIAL_PROPERTIES_LIST = 'commercial-properties-list',

  RESIDENTIAL_PROPERTIES_LIST = 'residential-properties-list',

  AGRICULTURAL_LANDS_ON_RENT = 'agricultural-lands-on-rent',

  TENANT_DISPUTE_LIST = 'tenant-dispute-list',

  LITIGATION_COPIES = 'litigation-copies',

  WATER_BILLS = 'water-bills',

  PROPERTY_TAX_BILLS = 'property-tax-bills',

  GAS_CONNECTION_BILLS = 'gas-connection-bills',

  DIGITAL_RECORDS_OF_BILLS = 'digital-records-of-bills',

  LIST_OF_CASES = 'list-of-cases',

  CASE_FILES = 'case-files',

  INTERIM_FINAL_ORDERS = 'interim-final-orders',

  JUDGMENT_COPIES = 'judgment-copies',

  APPEALS_FILED = 'appeals-filed',

  CLOSED_CASES = 'closed-cases',

  ONGOING_CASES = 'ongoing-cases',

  ADVOCATE_DETAILS = 'advocate-details',

  CASE_DOCUMENT = 'case-document',

  // ================= TENANT =================
  RENT_AGREEMENT_DOCUMENT = 'rent-agreement-document',

  RENT_RECEIPT = 'rent-receipt',

  // ================= LAND =================
  SANAD = 'sanad',

  REGISTRATION_DOCUMENT = 'registration-document',

  TITLE_DEED = 'title-deed',

  PROPERTY_MAP = 'property-map',

  TITLE_CLEARANCE = 'title-clearance',

  PAYMENT_PROOF = 'payment-proof',

  STAMP_DUTY_PROOF = 'stamp-duty-proof',

  SALE_GIFT_DEED = 'sale-gift-deed',

  LATEST_PROPERTY_TAX_RECEIPT = 'latest-property-tax-receipt',

  SURVEY_NUMBER_RECORDS = 'survey-number-records',

  MUTATION_RECORD_PROOF = 'mutation-record-proof',

  MUTATION_ENTRIES_ROR = 'mutation-entries-ror',

  OLD_OWNERSHIP_DOCUMENTS = 'old-ownership-documents',

  TITLE_SEARCH_REPORT = 'title-search-report',

  GOVERNMENT_ALLOTMENT_LETTERS = 'government-allotment-letters',

  NOTICE_135D = '135d-notice',

  VILLAGE_FORM_7_12 = 'village-form-7-12',

  VILLAGE_FORM_8A = 'village-form-8a',

  FORM_6_HAQ_PATRAKA = 'form-6-haq-patraka',

  FORM_6_HAQ_PATRAKA_NONDH = 'form-6-haq-patraka-nondh',

  FIFTY_TWO_FIFTY_THREE_UTARA = '52-53-utara',

  TALATI_MAP = 'talati-map',

  COLLECTOR_ORDER = 'collector-order',

  LEASE_DEEDS = 'lease-deeds',

  ENCUMBRANCE_CERTIFICATE = 'encumbrance-certificate',

  LAND_PHOTO = 'land-photo',
}
